import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../data/mock";

export default function FAQ() {
  return (
    <section className="px-5 py-24 md:px-10 md:py-28">
      <div className="mx-auto max-w-[860px]">
        <div className="text-center">
          <span className="text-[12px] font-semibold tracking-widest-custom uppercase text-[#9c8345]">
            Dúvidas frequentes
          </span>
          <h2 className="font-serif-display mt-4 text-[38px] leading-[1.1] text-[#0e1a2b] md:text-[52px]">
            Perguntas e respostas
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#e2dccb]"
            >
              <AccordionTrigger className="py-6 text-left font-serif-display text-[20px] text-[#0e1a2b] hover:no-underline md:text-[22px]">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-[14px] leading-relaxed text-[#54657a]">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
